import { Injectable } from '@angular/core';
import { CookieService } from '~shared/services/cookie.service';
import { createUserRegionCookieExpiration } from '~shared/modules/region-selector/utils/region-selector-cookies.util';
import { USER_REGION } from '~shared/modules/region-selector/constants/user-region-cookie.constant';
import { MULTIMARKETS_CENTRAL_REGIONS } from '~app/modules/generic/constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { RegionList } from '~shared/modules/region-selector/models/region-list.model';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { CountryCode, FeatureToggleEnum } from '~shared/constants';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as fromHeader from '~app/modules/generic/store';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class RegionSelectorService {
  userRegion$ = new BehaviorSubject<string>('');
  regionSelector$ = this.featureFlagService.isFeatureEnabledForCurrentCountry$(FeatureToggleEnum.REGION_SELECTOR);
  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private readonly featureFlagService: ActiveFeaturesConfigcatService,
    private store: Store<fromHeader.BuyerState>,
  ) {}

  ngOnDestroy() {
    this.userRegion$.complete();
  }
  public getActiveRegionSelector() {
    return this.regionSelector$.pipe(
      tap((ffValue: boolean) => {
        if (!ffValue) {
          this.clearUserRegionCookie();
          this.notifyUserRegion('');
        }
      })
    );
  }

  public fetchRegions(): Observable<RegionList> {
    const market: CountryCode = MarketDetectionUtil.getCountryCode();
    const multiMarketsURL = MULTIMARKETS_CENTRAL_REGIONS();
    return this.http.get<RegionList>(`${multiMarketsURL}/regions/${market}/children`);
  }

  public setUserRegion(userRegion: string): void {
    const expires = createUserRegionCookieExpiration();
    this.cookieService.set(USER_REGION, userRegion, expires, '/');

    this.notifyUserRegion(userRegion);
    this.store.dispatch(new fromHeader.LoadCategories());
  }

  public getUserRegion() {
    return this.cookieService.get(USER_REGION);
  }

  public notifyUserRegion(userRegion: string): void {
    this.userRegion$.next(userRegion);
  }

  private clearUserRegionCookie() {
    this.cookieService.delete(USER_REGION, '/');
  }
}
